import { render, staticRenderFns } from "./ShowAllNotifications.vue?vue&type=template&id=47e81a5b&scoped=true"
import script from "./ShowAllNotifications.vue?vue&type=script&lang=js"
export * from "./ShowAllNotifications.vue?vue&type=script&lang=js"
import style0 from "./ShowAllNotifications.vue?vue&type=style&index=0&id=47e81a5b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e81a5b",
  null
  
)

export default component.exports